const GRADE_OVERRIDE_HISTORY_ERROR_DEFAULT_MSG = 'Error retrieving grade override history.';

export default GRADE_OVERRIDE_HISTORY_ERROR_DEFAULT_MSG;
